import type { UserRole } from '~/prisma/enums'

/**
 * @description This function checks if passed userRoles has a specific role or any of the roles in an array.
 * @param {UserRole[]} [userRoles] - The roles of the user.
 * @param {readonly UserRole[]} rolesToCheck - The roles to check against the user's roles.
 * @param {boolean} [isAdminEveryRole] - If true, the function will return true if the user has the 'admin' role, regardless of other roles.
 * @returns {boolean} - Returns true if the user has the specified role(s) or admin role, false otherwise.
 */
export default function hasAnyRole(
  userRoles: UserRole[],
  rolesToCheck: readonly UserRole[],
  isAdminEveryRole = false,
): boolean {
  if (userRoles.length === 0) {
    return false
  }

  const userRolesSet = new Set(userRoles)

  if (isAdminEveryRole && userRolesSet.has('admin')) {
    return true
  }

  // If no role is specified: no access
  if (rolesToCheck.length === 0) {
    return false
  }

  return rolesToCheck.some(role => userRolesSet.has(role))
}
